export const DASHBOARD_LOGIN_URL = 'https://dashboard.stripe.com/';
export const DASHBOARD_EXPRESS_URL = 'https://dashboard.stripe.com/express';
export const PAYPAL_USER_AGREEMENT_URL =
  'https://www.paypal.com/us/legalhub/paypal/useragreement-full';
export const STRIPE_CONNECT_TERMS_URL = 'https://stripe.com/legal/connect-account/recipient';
export const BITPAY_EXCHANGE_RATES_URL = 'https://bitpay.com/exchange-rates/';
export const BITPAY_TOS_URL = 'https://bitpay.com/legal/terms-of-use/';
